import { env } from '../services/EnvironmentVariables'
import { v4 as uuidv4 } from 'uuid'
import { persistent } from '../services/LocalStorage'

function generateAppSerialId() {
    return 'muse:app:' + uuidv4()
}

export function getAppSerialId() {
    if (env.IS_ELECTRON) {
        // should be loaded by call to ElectronIPC.
        return env.APP_SERIAL_ID
    } else {
        if (env.APP_SERIAL_ID) {
            return env.APP_SERIAL_ID
        }

        // find from browser's localStorage or generate one.
        const cached = persistent.getString('appSerialId')
        if (cached) {
            return cached
        } else {
            const appSerialId = generateAppSerialId()
            persistent.set('appSerialId', appSerialId)
            env.APP_SERIAL_ID = appSerialId
            return appSerialId
        }
    }
}
